import { render, staticRenderFns } from "./StatsUnclaimedTaxes.vue?vue&type=template&id=ba410316&"
import script from "./StatsUnclaimedTaxes.vue?vue&type=script&lang=js&"
export * from "./StatsUnclaimedTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports